/**
 * 获取仓库数据分析看板
 */
import request from "_private/utils/request";
// 获取车辆数据
export function fetchVehicleData() {
  return request({
    url: "/board/warehouseMonitor/importVehicleData",
    method: "post"
  });
}
// 30天运营走势
export function fetchVehicleTrendData() {
  return request({
    url: "/board/warehouseMonitor/importVehcileMonth",
    headers: { type: "json" },
    method: "post"
  });
}
// 入库预约分析
export function fetchInstorageData() {
  return request({
    url: "/board/warehouseAnalysisBoard/InboundReservationAnalysis",
    method: "post"
  });
}
// 汇总数据
export function fetchTotalData() {
  return request({
    url: "/board/warehouseAnalysisBoard/getPlatformInfo",
    method: "post"
  });
}
